import ElementPoint from "../model/ElementPoint";

import {
  originPoint2LocalPoint,
  translateLocalToOrigin,
  getPointAfterCanvasRotate,
  getOrigin2LocalPoint,
} from "./MyMapUtils";
import BasePoint from "../model/BasePoint";
import HeadingPoint from "@/model/HeadingPoint";
import PointBean from "@/model/PointBean";
import LaneInfo from "@/model/LaneInfo";
import LocLaneInfo from "@/model/LocLaneInfo";
import MapElement2 from "@/model/MapElement2";
import LocMapElement2 from "@/model/LocMapElement2";

const mapPixelExtent = 0.05; //一像素代表的长度

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export default function useConvertMapElement() {
  let leftBoundary: number;
  let downBoundary: number;
  let mapPicWidth: number; //图片的宽和高
  let mapPicHeight: number; //图片的宽和高

  const setMapPicInfoForConvert = (
    left_boundary: number,
    down_boundary: number,
    mapPic_width: number,
    mapPic_height: number
  ) => {
    leftBoundary = left_boundary;
    downBoundary = down_boundary;
    mapPicWidth = mapPic_width;
    mapPicHeight = mapPic_height;
  };

  const getImgWH = (
    lane: LaneInfo,
    callBack: (w: number, h: number) => void
  ) => {
    const img = new Image();
    img.src = lane.lane_url;
    img.onload = () => {
      if (callBack) {
        callBack(img.naturalWidth, img.naturalHeight);
      }
    };
  };

  const get2LocalPoint = (xg: number, yg: number) => {
    const locPoint = new Object() as BasePoint;
    const mPoint = originPoint2LocalPoint(
      xg,
      yg,
      leftBoundary,
      downBoundary,
      mapPixelExtent,
      mapPicWidth,
      mapPicHeight
    );
    locPoint.x = mPoint.localX;
    locPoint.y = mPoint.localY;
    return locPoint;
  };

  const get2OriginPoint = (x: number, y: number) => {
    const mapPoint = new Object() as ElementPoint;
    const locPoint = translateLocalToOrigin(
      x,
      y,
      leftBoundary,
      downBoundary,
      mapPixelExtent,
      mapPicWidth,
      mapPicHeight
    );
    mapPoint.xg = locPoint.originX;
    mapPoint.yg = locPoint.originY;
    return mapPoint;
  };

  const getCarPosition2Local = (
    global_x: number,
    global_y: number,
    heading: number
  ) => {
    const carPosition = new Object() as HeadingPoint;
    if (leftBoundary != undefined && downBoundary != undefined) {
      const locPoint = originPoint2LocalPoint(
        global_x,
        global_y,
        leftBoundary,
        downBoundary,
        mapPixelExtent,
        mapPicWidth,
        mapPicHeight
      );
      carPosition.x = locPoint.localX;
      carPosition.y = locPoint.localY;
      carPosition.heading = heading + 90;
      return carPosition;
    } else {
      return null;
    }
  };

  const getMapElement2Local = (element: MapElement2) => {
    const locMapElement = new Object() as LocMapElement2;
    if (element && element.points.length > 0) {
      const locPoints = new Array<PointBean>();
      element.points.forEach((point) => {
        const pointBean = {} as PointBean;
        const locPoint = get2LocalPoint(point.xg, point.yg);
        pointBean.x = locPoint.x;
        pointBean.y = locPoint.y;
        pointBean.heading = point.heading;
        locPoints.push(pointBean);
      });
      locMapElement.id = element.id;
      locMapElement.main_type = element.main_type;
      locMapElement.sub_type = element.sub_type;
      locMapElement.name = element.name;
      locMapElement.sqlite_id = element.sqlite_id;
      locMapElement.vin = element.vin;
      locMapElement.map_id = element.map_id;
      locMapElement.points = locPoints;
      locMapElement.extension = element.extension;
    }
    return locMapElement;
  };

  const getMapElements2Local = (elements: MapElement2[]) => {
    const elementList = new Array<LocMapElement2>();
    if (elements && elements.length > 0) {
      elements.forEach((ele) => {
        const element = getMapElement2Local(ele);
        elementList.push(element);
      });
    }
    return elementList;
  };

  const getRotateTranslate = (x: number, y: number, rotateAngle: number) => {
    //获取地图旋转后的偏移量
    const lx = x;
    const ly = y;
    const pointLoc = getPointAfterCanvasRotate(lx, ly, rotateAngle);
    const tx = pointLoc.x;
    const ty = pointLoc.y;
    return { tx, ty };
  };
  const translateOriginPoint2Center = (
    xg: number,
    yg: number,
    rotateAngle: number
  ) => {
    //把某地图原始坐标位置移到视觉中心点要平移的距离
    const locPoint = originPoint2LocalPoint(
      xg,
      yg,
      leftBoundary,
      downBoundary,
      mapPixelExtent,
      mapPicWidth,
      mapPicHeight
    );
    const translateCenter = getRotateTranslate(
      locPoint.localX,
      locPoint.localY,
      rotateAngle
    );
    return translateCenter;
  };

  const getLaneInfo2Local = (lane: LaneInfo) => {
    const locLane = {} as LocLaneInfo;
    const pointBean = {} as BasePoint;
    const locPoint = get2LocalPoint(
      lane.left_up_coordinate.xg,
      lane.left_up_coordinate.yg
    );
    pointBean.x = locPoint.x;
    pointBean.y = locPoint.y;
    locLane.left_up_coordinate = pointBean;
    locLane.lane_id = lane.lane_id;
    locLane.lane_name = lane.lane_name;
    locLane.lane_type = lane.lane_type;
    locLane.lane_length = lane.lane_length;
    locLane.lane_area = lane.lane_area;
    locLane.lane_geometry = lane.lane_geometry;
    locLane.lane_url = lane.lane_url;
    return locLane;
  };

  const getLaneInfos2LocalMap = (lanes: LaneInfo[]) => {
    const locLanes = new Map<number, LocLaneInfo>();
    if (lanes && lanes.length > 0) {
      lanes.forEach((ele) => {
        const element = getLaneInfo2Local(ele);
        locLanes.set(ele.lane_id, element);
      });
    }
    return locLanes;
  };

  const get2LocalPoint2 = (xg: number, yg: number) => {
    const locPoint = new Object() as BasePoint;
    const mPoint = getOrigin2LocalPoint(
      xg,
      yg,
      leftBoundary,
      downBoundary,
      mapPixelExtent,
      mapPicWidth,
      mapPicHeight
    );
    locPoint.x = mPoint.localX;
    locPoint.y = mPoint.localY;
    return locPoint;
  };

  const getMapElement2Local2 = (element: MapElement2) => {
    const locMapElement = new Object() as LocMapElement2;
    if (element && element.points.length > 0) {
      const locPoints = new Array<PointBean>();
      element.points.forEach((point) => {
        const pointBean = {} as PointBean;
        const locPoint = get2LocalPoint2(point.xg, point.yg);
        pointBean.x = locPoint.x;
        pointBean.y = locPoint.y;
        pointBean.heading = point.heading;
        locPoints.push(pointBean);
      });
      locMapElement.id = element.id;
      locMapElement.main_type = element.main_type;
      locMapElement.sub_type = element.sub_type;
      locMapElement.name = element.name;
      locMapElement.sqlite_id = element.sqlite_id;
      locMapElement.vin = element.vin;
      locMapElement.map_id = element.map_id;
      locMapElement.points = locPoints;
      locMapElement.extension = element.extension;
      if (locMapElement.extension) {
        locMapElement.extension.blind_road_width =
          element.extension?.blindRoadWidth;
        locMapElement.extension.floor_lamps_radius =
          element.extension?.floorLampsRadius;
        locMapElement.extension.is_air_shower = element.extension?.isAirShower;
        if (element.extension?.elevatorDoorDir != undefined) {
          locMapElement.extension.elevator_door_dir =
            element.extension?.elevatorDoorDir;
        }
        if (element.extension?.isDoubleDoorElevator != undefined) {
          locMapElement.extension.is_double_door_elevator =
            element.extension?.isDoubleDoorElevator;
        }
      }
    }
    return locMapElement;
  };

  const getMapElements2Local2 = (elements: MapElement2[]) => {
    const elementList = new Array<LocMapElement2>();
    if (elements && elements.length > 0) {
      elements.forEach((ele) => {
        const element = getMapElement2Local2(ele);
        elementList.push(element);
      });
    }
    return elementList;
  };

  return {
    mapPixelExtent,
    setMapPicInfoForConvert,
    getCarPosition2Local,
    getMapElements2Local,
    getMapElement2Local,
    translateOriginPoint2Center,
    getLaneInfos2LocalMap,
    getMapElements2Local2,
  };
}
